import { observer } from "mobx-react-lite";
import * as React from "react";
import { useEffect } from "react";
import { Button, Pagination, Col, Row, message   } from 'antd';
import { useStore } from "../../root-store-context";
import utilsFunc from '../../utils/utilsFunc'
import { UserManagerCompleteRegistration } from '../../types'
import { RenderModalCompleteRegistration } from "./microComponents/RenderModalCompleteRegistration";
import DynamicTable from "../../../../../../../Components/Table/Table";
import Spinner from "../../../../../../../Components/Spinner/Spiner";

export const TablePendingUserListToManager = observer(()=>{

    const [messageApi ,contextHolder] = message.useMessage();
    const {
        pendingUserListToManageStore: {
            dataPending, isLoading,emailCompleteRegistration,isOpenModalCompleteRegistration,
            getPendingUserListToManageAction, openModalCompleteRegistration, closedModalCompleteRegistration,
        }, 
        userListToManageStore: {
            data,
            getUserListToManageAction
        }
    } = useStore()

    const completeRegistration = (email:string) =>{
        const key = 'completeRegistration';
        messageApi.open({
            type: 'loading',
            key,
            content: `We are completing registration for ${email}...`,
        });
        closedModalCompleteRegistration()
        utilsFunc.completeRegistrationFunc(email).then((result: UserManagerCompleteRegistration)=>{
            if (result.status === 'AlreadyCompleted') {
                messageApi.open({
                    type: 'warning',
                    key,
                    content: result.message || "Already Completed Registration",
                    duration: 5
                });
                return;
            }

            const messageType: 'success' | 'error' = result.status === 'Success' ? 'success' : 'error';

            messageApi.open({
                type: messageType,
                key,
                content: result.message,
                duration: 5
            });

            // Refresh lists only on success
            if (messageType === 'success') {
                getPendingUserListToManageAction(dataPending?.search==null ? "" : dataPending?.search, dataPending?.pageNum)
                getUserListToManageAction(data?.search==null ? "" : data?.search, data?.pageNum)
            }
        }).catch(() => {
            messageApi.open({
                type: 'error',
                key,
                content: `An error occurred during user registration. Try again, please.`,
                duration: 5
            });
        })
    }

    const columns = [
        {
            title: "Email",
            dataIndex: 'email',
            key: 'email',
            render: (text) => (<span>{text}</span>)
        },
        {
            title: "Address",
            dataIndex: 'address',
            key: 'address',
            render: (text) => (<span>{text}</span>)
        },
        {
            title: "Property",
            dataIndex: 'property',
            key: 'property',
            render: (text) => (<span>{text}</span>)
        },
        {
            title: "",
            dataIndex: 'email',
            key: 'email',
            width: 200,
            render: (email) => (<Button type="primary" onClick={() => openModalCompleteRegistration(email)}>Complete Registration</Button>)
        }
    ]

    useEffect(() => {
        // Small delay so auth state and axios configuration are fully settled
        // before the initial fetch fires — prevents API failures on first login redirect.
        const timer = setTimeout(() => {
            getPendingUserListToManageAction();
        }, 400);
        return () => clearTimeout(timer);
    }, [])

    return (
        <div>
            {isLoading && <Spinner />}
            {contextHolder}
            <RenderModalCompleteRegistration 
                isOpen={isOpenModalCompleteRegistration} 
                onCancel={closedModalCompleteRegistration} 
                onOk={() => completeRegistration(emailCompleteRegistration)} 
                email={emailCompleteRegistration}
            />
            <div style={{ marginBottom: 16 }}>
                <Row>
                    <Col span={24}>
                        <DynamicTable
                            columns={columns}
                            data={dataPending?.users ?? []}
                            pagination={false}
                            rowKey="email"
                            onRow={() => ({})}
                            onChange={() => undefined}
                            scroll={{ x: 'max-content', y: 'calc(100vh - 300px)' }}
                        />
                    </Col>
                </Row>
            </div>
            <Row>
                <Col span={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>{
                    !isLoading && dataPending?.users?.length > 0 ?
                        <Pagination onChange={(target)=> {getPendingUserListToManageAction(dataPending?.search==null ? "" : dataPending?.search,target - 1)}} showTotal={() => `${dataPending?.from+1}-${dataPending?.to} of ${dataPending?.total} items`} current={dataPending?.pageNum+1} total={dataPending?.total} defaultPageSize={20} showSizeChanger={false} /> 
                        :
                        <></>
                    }
                </Col>
            </Row>
        </div>
    )
})
